var React = require('react');

function Taxi (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.766 7h20.499c.541 0 .858-.418.703-.928l-1.376-4.143C41.438 1.418 40.869 1 40.328 1H23.703c-.541 0-1.11.418-1.265.929l-1.376 4.143c-.154.51.163.928.704.928zm35.197 5.177C56.257 10.149 54.456 8 52.2 8H14.061c-2.256 0-4.188 2.149-4.894 4.177L1 31.972v27.5C1 61.363 2.556 63 4.45 63h3.444C9.806 63 11 61.363 11 59.472V56h42v3.472C53 61.363 54.455 63 56.367 63h3.444C61.706 63 63 61.363 63 59.472v-27.5l-6.037-19.795zM13 45.43c-2.772 0-5.01-2.233-5.01-5s2.238-5 5.01-5 5.01 2.233 5.01 5-2.238 5-5.01 5zm38.262 0c-2.772 0-5.01-2.233-5.01-5s2.238-5 5.01-5 5.01 2.233 5.01 5-2.238 5-5.01 5zM32.006 28H7.895l6.167-14H52.2l4.167 14H32.006z"}));
}

Taxi.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = Taxi;

Taxi.default = Taxi;
